import * as React from 'react';
import { RenderHtml } from '../../../utils';
export var TextComponent = function (props) {
    var handleOrderedListOffset = function (elem) {
        if (elem) {
            var maybeOrderedList = elem.querySelector('.inner-text-component-html > ol');
            if (maybeOrderedList) {
                var listNumberingStart = props.listOffset + 1;
                maybeOrderedList.setAttribute('start', listNumberingStart.toString());
            }
        }
    };
    var handleVRIcons = function (elem) {
        if (elem) {
            Array.from(elem.querySelectorAll('img')).forEach(function (icon) { return icon.setAttribute('aria-hidden', 'true'); });
        }
    };
    var orderedListOffsetHandler = function (elem) {
        handleOrderedListOffset(elem);
        handleVRIcons(elem);
    };
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return (React.createElement("div", { className: "component text-component".concat(isSafari ? ' is-safari' : ''), ref: orderedListOffsetHandler, "data-component-type": 'text' },
        React.createElement(RenderHtml, { className: 'inner-text-component-html', html: props.value.html, useDiv: true })));
};
//# sourceMappingURL=text-component.comp.js.map